import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isnullorempty'
})
export class IsNullOrEmptyPipe implements PipeTransform {

  transform(value: object): boolean {
    return value === null || value === undefined || (typeof value === "string" && new String(value) === ''); 
  }
}
